/**
 * Equivalente a $(document).ready() do jQuery
 * @param fn
 */
export const ready = (fn) => {
  (document.readyState !== "loading" && fn()) ||
  document.addEventListener("DOMContentLoaded", fn);
}